import {
  Directive,
  Output,
  HostListener,
  EventEmitter,
  Input,
} from '@angular/core';
import {Persona} from '../models/dbresponses.interface';
import {AlertController} from '@ionic/angular';
import {Router} from '@angular/router';

/** Guard for not-yet validated user
 * Used on buttons to stop the flux until the user validates their email
 * Receives first the callback funciton that normally would be on a (click) and the user to ve checked.
 */
@Directive({
  selector: '[validateUser]',
})
export class ValidateUser {
  @Output() validateClick: EventEmitter<any> = new EventEmitter();
  @Input() validateCallback!: any;
  @Input() currentUser!: Persona;

  constructor(
    private router: Router,
    private alertController: AlertController
  ) {}

  @HostListener('click', ['$event'])
  async onClick(e: any) {
    if (!this.currentUser.email_validado) {
      e.preventDefault();
      e.stopPropagation();
      const gateAlert = await this.alertController.create({
        header: 'ATENCIÓN',
        subHeader: 'Tu perfil está incompleto',
        message:
          'Porfavor valida tu email antes de continuar utilizando Monitor Austral',
        buttons: [
          {
            text: 'Validar',
            role: 'confirm',
            handler: () => this.router.navigateByUrl('validar'),
          },
        ],
      });

      return await gateAlert.present();
    } else {
      this.validateClick.next(e);
    }
  }
}
